import React from 'react';

// Comps
import {Headings} from '@arctheme-components/elements/Headings/Headings';
import {Link} from '@arctheme-components/elements/Link/Link';
import "./AccountAddress.scss"
import { Button } from '@src/stories/elements/Button/Button';
import Paragraph from '@src/stories/elements/Paragraph/Paragraph';

const Address = ({
  address,
  isDefault,
  index,
  onClickEdit,
  onClickRemove,
  locales
}: {
  address: any;
  isDefault: boolean;
  index: number;
  onClickEdit: (event: React.ClickEvent<HTMLAnchorElement>, address: any) => void;
  onClickRemove: (event: React.ClickEvent<HTMLAnchorElement>, addressId: number) => void;
  locales: any;
}) => {
  const { firstName, lastName, company, address1, address2, city, province, zip, country, phone } = address;

  locales.defaultAddress = 'Primary Address';
  return (
    <div className='flex flex-col justify-between gap-y-3'>
      <div className='flex flex-col gap-y-1'>
        <Paragraph
          type='b2--bold'
          text={isDefault ? locales.defaultAddress : `Address ${index + 1}`}
          classes=''
        />

        <p className='py-[8px] b-address'>
          {(firstName || lastName) && (
            <>
              {firstName} {lastName}
              <br />
            </>
          )}
          {company && (
            <>
              {company}
              <br />
            </>
          )}
          {address1 && (
            <>
              {address1}
              <br />
            </>
          )}
          {address2 && (
            <>
              {address2}
              <br />
            </>
          )}
          {city && (
            <>
              {city}
              <br />
            </>
          )}
          {(province || zip) && (
            <>
              {province} {zip}
              <br />
            </>
          )}
          {country && (
            <>
              {country}
              <br />
            </>
          )}
          {phone && (
            <>
              {phone}
              <br />
            </>
          )}
        </p>
      </div>
      <div className='flex justify-between gap-x-2'>
        <Button
        text={true}
          label={locales.edit}
          classes={`link w-full`}
          link={'#'}
          styleType={'link'}
          onClick={(e) => onClickEdit(e, address)}
        />

        <Button
        text={true}
          classes={`link w-full`}
          link={'#'}
          styleType={'link'}
          onClick={(e) => onClickRemove(e, address.id)}
          label={locales.delete}
        />
      </div>
    </div>
  );
};

export default Address;
